/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Update_ButtonInputs */

const en_edit_event_group_update_button = /** @type {(inputs: Edit_Event_Group_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Group`)
};

const fr_edit_event_group_update_button = /** @type {(inputs: Edit_Event_Group_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour le groupe`)
};

const de_edit_event_group_update_button = /** @type {(inputs: Edit_Event_Group_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update-Gruppe`)
};

const it_edit_event_group_update_button = /** @type {(inputs: Edit_Event_Group_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna gruppo`)
};

const ru_edit_event_group_update_button = /** @type {(inputs: Edit_Event_Group_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа обновлений`)
};

const es_edit_event_group_update_button = /** @type {(inputs: Edit_Event_Group_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de actualización`)
};

const zh_cn2_edit_event_group_update_button = /** @type {(inputs: Edit_Event_Group_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新组`)
};

const ja_edit_event_group_update_button = /** @type {(inputs: Edit_Event_Group_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新グループ`)
};

const hi_edit_event_group_update_button = /** @type {(inputs: Edit_Event_Group_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह को अपडेट करें`)
};

const pt_pt2_edit_event_group_update_button = /** @type {(inputs: Edit_Event_Group_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de atualização`)
};

/**
* | output |
* | --- |
* | "Update Group" |
*
* @param {Edit_Event_Group_Update_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_update_button = /** @type {((inputs?: Edit_Event_Group_Update_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Update_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_update_button(inputs)
	if (locale === "de") return de_edit_event_group_update_button(inputs)
	if (locale === "it") return it_edit_event_group_update_button(inputs)
	if (locale === "ru") return ru_edit_event_group_update_button(inputs)
	if (locale === "es") return es_edit_event_group_update_button(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_update_button(inputs)
	if (locale === "ja") return ja_edit_event_group_update_button(inputs)
	if (locale === "hi") return hi_edit_event_group_update_button(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_update_button(inputs)
	return en_edit_event_group_update_button(inputs)
});